import { legibleOn } from '../../utils/legibleOn';
import { sanitizeHexColor } from '../../utils/sanitizeHexColor';
import { GLYPH_PATHS, GLYPH_DEFAULT, LEGACY_ALIASES } from '../../theme/categoryGlyphs';
import { HOLLOW } from '../../theme/colors';

interface Props {
  categoryId: string;
  size?: number;
  /** Primary fill. If omitted and `bgColor` is provided, derived from `legibleOn(bgColor)`. */
  color?: string;
  /** Actual category background color — used for cutouts inside the glyph so they read against the surrounding cream mass. When absent, cutouts fall back to a fixed cream. */
  bgColor?: string;
  className?: string;
}

export function CategoryGlyph({ categoryId, size = 18, color, bgColor, className }: Props) {
  const raw = (categoryId ?? '').toLowerCase();
  const id = LEGACY_ALIASES[raw] ?? raw;
  const resolvedColor = sanitizeHexColor(color ?? (bgColor ? legibleOn(bgColor) : 'currentColor'));
  const resolvedBg = sanitizeHexColor(bgColor ?? HOLLOW);
  const paths = GLYPH_PATHS[id] ?? GLYPH_DEFAULT;
  const html = paths.replaceAll('FG', resolvedColor).replaceAll('BG', resolvedBg);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      aria-hidden="true"
      className={className}
      // Glyph strings come from a controlled static import — no user data here.
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
